module.exports = __webpack_public_path__ + "static/media/4.817dc504.JPG";